import { useCachedBannerResponseStore } from "@faire/deprecated-retailer-visitor-shared/components/Banners/CachedBannerResponseStore";
import { useBannersData } from "@faire/deprecated-retailer-visitor-shared/components/Banners/DataFetching/__internal__/useBannersData";
import { LoggedOutCategoryResultsBanner } from "@faire/deprecated-retailer-visitor-shared/components/Banners/LoggedOutCategoryBanners/LoggedOutCategoryResultsBanner";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useCategoryPageFilterKeys } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import { ISearchCatNavBannersRequest } from "@faire/web-api--source/indigofair/data/ISearchCatNavBannersRequest";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useLoggedOutCategoryPageBannersResponse = () => {
  const filter_keys = useCategoryPageFilterKeys();
  const navigation_path = useLoggedOutCategoryPageCurrentNavigationPath();
  const request = ISearchCatNavBannersRequest.build({
    navigation_path,
    filter_keys,
  });
  const { cachedRequest: fetchCategoryPageBanners } =
    useCachedBannerResponseStore(["cachedRequest"]);

  const { data: bannersResponse } = useQuery({
    queryKey: [request],
    queryFn: () => fetchCategoryPageBanners(request),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });

  const firstBannerRow = useResponsiveValue({
    mobileAndAbove: 4,
    tabletAndAbove: 3,
  });
  const secondBannerRow = useResponsiveValue({
    mobileAndAbove: 8,
    tabletAndAbove: 6,
  });

  const signUpProductGridBanner = useMemo(() => {
    return {
      type: LoggedOutCategoryResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER,
      fullRowBanner: true,
      size: 0,
      column: 1,
      row: firstBannerRow,
    };
  }, [firstBannerRow]);

  const eligibleBannersDisplayDataInPriorityOrder = useMemo(() => {
    const { filter_pill_banner, sign_up_product_grid_banner } =
      bannersResponse ?? {};

    return [
      sign_up_product_grid_banner ? signUpProductGridBanner : undefined,
      filter_pill_banner
        ? {
            type: LoggedOutCategoryResultsBanner.FILTER_PILL_TILE,
            size: 1,
            column: 4,
            row: secondBannerRow,
          }
        : undefined,
    ].filter(isNotUndefined);
  }, [bannersResponse, secondBannerRow, signUpProductGridBanner]);

  const { displayableBannersWithAdjustedRow } =
    useBannersData<LoggedOutCategoryResultsBanner>(
      eligibleBannersDisplayDataInPriorityOrder
    );

  return useMemo(
    () => ({
      bannersResponse,
      bannersDisplayData: eligibleBannersDisplayDataInPriorityOrder,
      displayableBannersWithAdjustedRow,
    }),
    [
      bannersResponse,
      eligibleBannersDisplayDataInPriorityOrder,
      displayableBannersWithAdjustedRow,
    ]
  );
};
